import _define_property from "@swc/helpers/src/_define_property.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Text } from "@cinch-labs/design-system";
import cx from "classnames";
import React from "react";
import skeletonStyles from "../skeleton.module.css";
import styles from "./price.module.css";
export var numberWithCommas = function(x) {
    if (typeof x === "string") {
        return Number.parseInt(x.replace(/,/g, ""), 10).toLocaleString();
    }
    return Math.round(x).toLocaleString();
};
var penceToPounds = function(n) {
    return Math.round(n / 100);
};
var Price = function(param) {
    var price = param.price, vehicleId = param.vehicleId, _shouldShowCarsOnOfferTag = param.shouldShowCarsOnOfferTag, shouldShowCarsOnOfferTag = _shouldShowCarsOnOfferTag === void 0 ? false : _shouldShowCarsOnOfferTag, discountInPence = param.discountInPence, isPending = param.isPending, _showSmallFontSize = param.showSmallFontSize, showSmallFontSize = _showSmallFontSize === void 0 ? false : _showSmallFontSize;
    var fullPrice = "\xa3".concat(numberWithCommas(price));
    var wasPriceId = "".concat(vehicleId, "-was-price");
    var renderCashPrice = function() {
        var _obj;
        return /*#__PURE__*/ _jsx(Text, {
            element: "span",
            fontSizeFixed: "l",
            fontWeight: "semibold",
            "aria-label": "Cash price. ".concat(fullPrice, "."),
            "aria-describedby": discountInPence ? wasPriceId : undefined,
            className: cx(styles.cashPrice, (_obj = {}, _define_property(_obj, skeletonStyles.base, isPending), _define_property(_obj, skeletonStyles.active, isPending), _obj)),
            children: fullPrice
        });
    };
    var renderCashPriceAndWasPrice = function() {
        var discount = penceToPounds(discountInPence !== null && discountInPence !== void 0 ? discountInPence : 0);
        var wasPrice = "\xa3".concat(numberWithCommas(price + discount));
        var _obj;
        return /*#__PURE__*/ _jsxs("div", {
            className: styles.cashPrice,
            children: [
                /*#__PURE__*/ _jsxs(Text, {
                    element: "span",
                    id: wasPriceId,
                    "data-testid": "was-price",
                    fontSizeFixed: "xs",
                    fontWeight: "medium",
                    "aria-hidden": true,
                    className: cx(styles.wasPrice, (_obj = {}, _define_property(_obj, skeletonStyles.base, isPending), _define_property(_obj, skeletonStyles.active, isPending), _obj)),
                    children: [
                        "Was ",
                        /*#__PURE__*/ _jsx("s", {
                            children: wasPrice
                        })
                    ]
                }),
                renderCashPrice()
            ]
        });
    };
    return /*#__PURE__*/ _jsx("div", {
        className: cx(styles.priceContainer, _define_property({}, styles.smallFontSize, showSmallFontSize)),
        children: shouldShowCarsOnOfferTag ? renderCashPriceAndWasPrice() : renderCashPrice()
    });
};
export default Price;
